import { motion, type Variants } from 'framer-motion';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'span' | 'li' | 'article';
}

const variants: Variants = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.2, 0.7, 0.2, 1] },
  },
};

export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div',
}: RevealProps): React.ReactNode {
  const MotionTag = motion[as];
  return (
    <MotionTag
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-15% 0px' }}
      transition={{ delay }}
      variants={variants}
      className={className}
    >
      {children}
    </MotionTag>
  );
}
